import { useState, useEffect } from 'react';

export const useRichTextEditor = ({ hasSelectedNode, alwaysShowEditor }) => {
  const [editable, setEditable] = useState(alwaysShowEditor);

  useEffect(() => {
    if (alwaysShowEditor) {
      setEditable(true);
    } else {
      !hasSelectedNode && setEditable(false);
    }
  }, [hasSelectedNode, alwaysShowEditor]);

  return {
    editable,
    setEditable
  };
};
